var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rank"},[_c('my-table',{attrs:{"infos":_vm.info,"titles":_vm.titles}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }